//
// # Symbol Changes
//

// NPM Imports
import typia from "typia";

// Local Imports
import { validate as v, change as c } from "CoreUtils";
import type * as schema from "GenAlphaSchema";

export type SymbolChange = c.Change<Child> & { contentKind: "symbol" };

export const SymbolChange = {
  // Create an `Add` change
  add: (child: Child) =>
    ({
      contentKind: "symbol",
      changeKind: "add",
      data: child,
    } as const),
  // Create an `Update` change
  update: (id: number, data: c.Update<Child>) =>
    ({
      contentKind: "symbol",
      changeKind: "update",
      id,
      data,
    } as const),
  // Create a `Remove` change
  remove: (childKind: Child["targetKind"], id: number) =>
    ({
      contentKind: "symbol",
      changeKind: "remove",
      id,
      data: { targetKind: childKind },
    } as const),
  validator: new v.Validator(v.createValidate<SymbolChange>()),
  stringify: typia.json.createStringify<SymbolChange>(),
};

// Symbol Child Elements
// with targetKind change tags
type Child =
  | (schema.symbol.SymbolPin & { targetKind: "pin" })
  | (schema.symbol.Expr & { targetKind: "exprlabel" })
  | (schema.core.Element & { targetKind: "graphics" })
  | (schema.core.SelectionBbox & { targetKind: "selectionbox" });
